import { message } from "antd";
import Cookies from "js-cookie";
import * as googleLibphonenumber from "google-libphonenumber";

const phoneUtil = googleLibphonenumber.PhoneNumberUtil.getInstance();
const PNF = googleLibphonenumber.PhoneNumberFormat;

declare global {
  interface Window {
    fbAsyncInit: () => void;
    FB: any;
    AppleID: any;
  }
}

export const formatPrice = (price: any) => {
  return (
    (price < 0 ? "-" : "") +
    String(price)
      .replace(/\D/g, "")
      .replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  );
};

export const isEmailValid = (email: string) => {
  let re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(email);
};

export const isPhoneValid = (phone: string) => {
  let phoneInput = phone;
  if (phone.startsWith("+840") || phone.startsWith("00")) {
    return false;
  }
  if (!phone.startsWith("+84") && !phone.startsWith("0")) {
    phoneInput = `0${phone}`;
  }
  try {
    const phoneNumber = phoneUtil.parse(phoneInput, "VN");
    return phoneUtil.isValidNumber(phoneNumber);
  } catch (e) {
    return false;
  }
};

export const convertPhone = (phone: string): string => {
  let phoneInput = phone;
  if (phone.startsWith("+840") || phone.startsWith("00")) {
    return phone;
  }
  if (!phone.startsWith("+84") && !phone.startsWith("0")) {
    phoneInput = `0${phone}`;
  }
  try {
    const phoneNumber = phoneUtil.parse(phoneInput, "VN");
    if (phoneUtil.isValidNumber(phoneNumber)) {
      return phoneUtil.format(phoneNumber, PNF.E164);
    }
    return phone;
  } catch (e) {
    return phone;
  }
};

export const showMessage = (
  type: "success" | "info" | "warning" | "error",
  text: string
) => {
  if (["success", "info", "warning", "error"].includes(type)) {
    message[type](text, 4.5);
  }
};

export const saveSession = (
  accessToken: any,
  refreshToken: string,
  expires: any
) => {
  Cookies.set("accessToken", accessToken, {
    domain: process.env.REACT_APP_SSO_DOMAIN,
    expires: expires / 86400,
  });

  Cookies.set("refreshToken", refreshToken, {
    domain: process.env.REACT_APP_SSO_DOMAIN,
  });
};

export const getAccessToken = () => {
  return Cookies.get("accessToken");
};

export const getRefreshToken = () => {
  return Cookies.get("refreshToken");
};

export const deleteSession = () => {
  Cookies.remove("accessToken", { domain: process.env.REACT_APP_SSO_DOMAIN });
  Cookies.remove("refreshToken", { domain: process.env.REACT_APP_SSO_DOMAIN });
};

export const getFbToken = async (): Promise<string | null> => {
  return new Promise((resolve) => {
    window.FB.getLoginStatus((response: any) => {
      if (response["status"] === "connected") {
        resolve(response.authResponse.accessToken);
      } else {
        window.FB.login((response: any) => {
          if (response["status"] === "connected") {
            resolve(response.authResponse.accessToken);
          } else {
            resolve(null);
          }
        });
      }
    });
  });
};

export const copyToClipboard = (text: string) => {
  const $body = document.getElementsByTagName("body")[0];
  const $tempInput = document.createElement("INPUT") as HTMLInputElement;
  $body.appendChild($tempInput);
  $tempInput.setAttribute("value", text);
  $tempInput.select();
  document.execCommand("copy");
  $body.removeChild($tempInput);
};

export const isPasswordValid = (email: string) => {
  let re = /((?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[ !@#$%^&*(),.?":{}|<>])).{8,}/;
  return re.test(email);
};

export const formatRole = (role: string) => {
  switch (role) {
    case "general_agency":
      return "Đại lý hạng Vàng";
    case "agency":
      return "Đại lý hạng Bạc";
    default:
      return "Cá nhân";
  }
};

export const removeVietnameseTonesEmail = (str: string) => {
  str = str.replace(/à|á|ạ|ả|ã|â|ầ|ấ|ậ|ẩ|ẫ|ă|ằ|ắ|ặ|ẳ|ẵ/g, "a");
  str = str.replace(/è|é|ẹ|ẻ|ẽ|ê|ề|ế|ệ|ể|ễ/g, "e");
  str = str.replace(/ì|í|ị|ỉ|ĩ/g, "i");
  str = str.replace(/ò|ó|ọ|ỏ|õ|ô|ồ|ố|ộ|ổ|ỗ|ơ|ờ|ớ|ợ|ở|ỡ/g, "o");
  str = str.replace(/ù|ú|ụ|ủ|ũ|ư|ừ|ứ|ự|ử|ữ/g, "u");
  str = str.replace(/ỳ|ý|ỵ|ỷ|ỹ/g, "y");
  str = str.replace(/đ/g, "d");
  str = str.replace(/À|Á|Ạ|Ả|Ã|Â|Ầ|Ấ|Ậ|Ẩ|Ẫ|Ă|Ằ|Ắ|Ặ|Ẳ|Ẵ/g, "A");
  str = str.replace(/È|É|Ẹ|Ẻ|Ẽ|Ê|Ề|Ế|Ệ|Ể|Ễ/g, "E");
  str = str.replace(/Ì|Í|Ị|Ỉ|Ĩ/g, "I");
  str = str.replace(/Ò|Ó|Ọ|Ỏ|Õ|Ô|Ồ|Ố|Ộ|Ổ|Ỗ|Ơ|Ờ|Ớ|Ợ|Ở|Ỡ/g, "O");
  str = str.replace(/Ù|Ú|Ụ|Ủ|Ũ|Ư|Ừ|Ứ|Ự|Ử|Ữ/g, "U");
  str = str.replace(/Ỳ|Ý|Ỵ|Ỷ|Ỹ/g, "Y");
  str = str.replace(/Đ/g, "D");
  // Some system encode vietnamese combining accent as individual utf-8 characters
  // Một vài bộ encode coi các dấu mũ, dấu chữ như một kí tự riêng biệt nên thêm hai dòng này
  str = str.replace(/\u0300|\u0301|\u0303|\u0309|\u0323/g, ""); // ̀ ́ ̃ ̉ ̣  huyền, sắc, ngã, hỏi, nặng
  str = str.replace(/\u02C6|\u0306|\u031B/g, ""); // ˆ ̆ ̛  Â, Ê, Ă, Ơ, Ư
  // Remove extra spaces
  // Bỏ các khoảng trắng liền nhau
  str = str.replace(/ + /g, " ");
  str = str.trim();
  // Remove punctuations
  // Bỏ dấu câu, kí tự đặc biệt
  // str = str.replace(/!|@|%|\^|\*|\(|\)|\+|\=|\<|\>|\?|\/|,|\.|\:|\;|\'|\"|\&|\#|\[|\]|~|\$|_|`|-|{|}|\||\\/g, ' ')
  return str;
};
